import { Theme } from "@mui/material";

export const modalBoxStyles = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "stretch",
  justifyContent: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  padding: "22px",
  boxShadow: 24,
  backgroundColor: theme.palette.modalColors.bgColor,
  width: { xs: "90%", sm: "70%", md: "60%" },
  height: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
  overflowY: "auto",
});

export const loadingBoxStyles = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "stretch",
  justifyContent: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  padding: "2rem 7rem",
  boxShadow: 24,
  backgroundColor: theme.palette.modalColors.bgColor,
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
  overflowY: "auto",
});

export const messagesContainerStyles = (theme: Theme) => ({
  background: theme.palette.adminPanel.previewBg,
  flexGrow: 1,
  overflowY: "auto",
  borderRadius: "10px",
  paddingX: "1rem",
});

export const buttonsContainerStyles = () => ({
  marginY: "1rem",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "1rem",
});

export const cancelButtonStyles = {
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  borderColor: "rgb(25, 118, 210)",
  color: "rgb(25, 118, 210)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "rgba(25, 118, 210, 0.1)",
  },
};

export const sendButtonStyles = {
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  background: "rgb(25, 118, 210)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "rgb(17, 100, 183)",
  },
};
